module.exports = __webpack_public_path__ + "img/icon_benefit-wellbeing.95507864.svg";